import React from 'react'

import { PersonAvatar, WorkspaceLogo } from '@sketch/components'
import { WorkspaceInvitedNotificationFragment } from '@sketch/gql-types'

import { AvatarWrapper } from './AddShareMemberPreview.styles'
import {
  Card,
  Separator,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface WorkspaceInvitedPreviewProps {
  notification: WorkspaceInvitedNotificationFragment
}

export const WorkspaceInvitedPreview = ({
  notification,
}: WorkspaceInvitedPreviewProps) => {
  const { user, workspace, title } = notification

  const inviterName = user?.name ?? 'Someone'
  const inviterAvatar = user?.avatar?.small
  const workspaceName = workspace?.name ?? title

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AvatarWrapper>
            {inviterAvatar ? (
              <PersonAvatar
                flavour="image"
                size="96px"
                name={inviterName}
                src={inviterAvatar}
              />
            ) : (
              <PersonAvatar flavour="color" size="96px" name={inviterName} />
            )}
          </AvatarWrapper>
          <TileTitle>{inviterName}</TileTitle>
          <TileMeta>Inviter</TileMeta>
        </Tile>

        <Separator />

        <Tile>
          <AvatarWrapper>
            <WorkspaceLogo
              size="88px"
              workspaceName={workspaceName}
              src={workspace?.avatar?.small}
            />
          </AvatarWrapper>
          <TileTitle>{workspaceName}</TileTitle>
          <TileMeta>Workspace</TileMeta>
        </Tile>
      </TileWrapper>
    </Card>
  )
}
